import React from "react";
import axiosAuth from "../Axios/Interceptors";
import axios from "axios";
import AppContext from "../Context/Context";
import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import LoadingAnimation from "../LoadingAnimation/LoadingAnimation";

import { UserManager, User, WebStorageStateStore } from "oidc-client";
import oidcConfig from "./oidc-config";
import { useGlobalState } from "../Context/GlobalStateContext";
import DragDrop from "../DragDrop/DragDrop";
import { SanitizeHtml, currentYearDisplay } from "../Shared/Utility";
function PFIJLRLGN() {
  const globalState = useGlobalState();

  // const [searchParams, setSearchParams] = useSearchParams();
  // let query = searchParams.get("q");
  // let app:any = searchParams.get("app");

  const params = new URLSearchParams(window.location.search);
  const lgo = params.get("lgo") as any;
  const query = params.get("q") as any;
  const app = params.get("app") as any;
  const api = params.get("api") as any;

  const [hideLoginBox, setHideLoginBox] = useState(true);
  const [showTwoFactorDiv, setShowTwoFactorDiv] = useState(false);
  const [twoFactorMessage, setTwoFactorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const [loadingState, setLoadingState] = useState(false);
  const [loginObject, setLoginObject] = useState({
    username: "",
    password: "",
    otp: "",
  });

  const [contactUsReason, setcontactUsReason] = useState([]);
  const [uploadFileList, setUploadFileList] = useState([]);
  const [triggerChild, setTriggerChild] = useState(false);
  const [ShowContact, SetShowContact] = useState(false);
  const [isOkToGo, setIsOkToGo] = useState(false);
  const ShowHideContact = () => {
    SetShowContact(!ShowContact);
  };

  const [contactObject, setcontactObject] = useState({
    Name: globalState.LogInUserName,
    Email: "",
    Subject: "",
    Message: "",
    ContactReason: 0,
  });

  const [dragDropFeatures, setDragDropFeatures] = useState({
    ObjectID: 0,
    ObjectType: 1,
    MaxAllowedFiles: 4,
    UploadType: 1,
    FolderName: "Contact",
    PTUploadedFiles: [],
  });

  function handleDragDropCallback(ChildData: any) {
    setUploadFileList(ChildData);
  }

  useEffect(() => {
    getContactUsPageData();
  }, []);

  useEffect(() => {
    if (query && query !== null && app && app !== null) {
      GetTokenDataFromKey(query);
    }
  }, [query, app]);

  useEffect(() => {
    if (lgo && lgo != "" && lgo == 1) {
      getUserLoggedOut();
    } else {
      checkLoginValidityAndGetKey();
    }
  }, [lgo, api]);

  function getUserLoggedOut() {
    setLoadingState(true);
    let object = {} as any;
    axiosAuth
      .post(AppContext.AppAuthBaseURL + "api/SiteUser/GetUserLoggedOut", object)
      .then((response) => {
        setHideLoginBox(false);
        if (response.data.Status === 1) {
        }
        setLoadingState(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setLoadingState(false);
        setHideLoginBox(false);
      });
  }

  function checkLoginValidityAndGetKey() {
    setLoadingState(true);
    let object = {} as any;
    axiosAuth
      .post(
        AppContext.AppAuthBaseURL + "api/SiteUser/CheckLoginValidityAndGetKey",
        object
      )
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data[0];
          if (l_response[0].Status == 1) {
            window.location = AppContext.LinkMBT as any;
          } else {
            setHideLoginBox(false);
          }
        } else {
          setHideLoginBox(false);
        }
        setLoadingState(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setHideLoginBox(false);
        setLoadingState(false);
      });
  }

  function GetTokenDataFromKey(query: any) {
    let object = {} as any;
    object.keydt = query;
    axios
      .post(
        AppContext.AppAuthBaseURL + "api/SiteUser/GetTokenDataFromKey",
        object,
        { withCredentials: true }
      )
      .then((response) => {
        if (app == 0) {
          window.location = AppContext.LinkMBT as any;
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function getContactUsPageData() {
    let object = {} as any;
    object.appid = AppContext.App;
    axios
      .post(AppContext.CommAPI + "api/PTSupport/GetSupportTypeList", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data[0];
          setcontactUsReason(l_response);
        } else {
          AppContext.ShowNotification("error", response.data.Message);
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }

  function checkValidation(takeAction: boolean) {
    if (
      contactObject.Name === "" ||
      contactObject.Email === "" ||
      contactObject.Message === "" ||
      contactObject.ContactReason === 0
    ) {
      if (takeAction) {
        globalState.setNotificationObject({
          ShowPopup: true,
          Heading: "Alert",
          Message: "You need to select from all the information to continue.",
        });
      }
      {
        setIsOkToGo(false);
      }
    } else {
      setIsOkToGo(true);
      if (takeAction) {
        SaveFiles();
      }
    }
  }

  function clearObject() {
    setcontactObject({
      Name: globalState.LogInUserName,
      Email: "",
      Subject: "",
      Message: "",
      ContactReason: 0,
    });
  }

  function SaveFiles() {
    setLoadingState(true);
    if (uploadFileList && uploadFileList.length > 0) {
      let object = {} as any;
      object.typeid = 1;
      object.attachmenttype = dragDropFeatures.ObjectType;
      object.objectid = dragDropFeatures.ObjectID;
      object.applicationid = 1;
      object.filesdata = uploadFileList;
      axiosAuth
        .post(
          AppContext.FileManegmentAPI + "api/PTAttachment/SaveFilesData",
          object
        )
        .then((response) => {
          if (response.data.Status === 1) {
            setTriggerChild(!triggerChild);
            let l_response = response.data.Data;
            saveConactUsData(l_response);
          } else {
            AppContext.ShowNotification("error", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("There was an error!", error);
        });
    } else {
      saveConactUsData([]);
    }
  }

  function saveConactUsData(p_S3UploadFileList: any) {
    setLoadingState(true);
    let object = {} as any;
    object.appid = AppContext.App;
    object.typeid = 1;
    object.ptsupporttypeid = contactObject.ContactReason;
    object.subject = "";
    object.firstname = contactObject.Name;
    object.email = contactObject.Email;
    object.contact = "";
    object.message = contactObject.Message;
    object.filesdata = p_S3UploadFileList;
    axiosAuth
      .post(AppContext.CommAPI + "api/PTSupport/SupportSubmitData", object)
      .then((response) => {
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          globalState.setNotificationObject({
            ShowPopup: true,
            Heading: "Alert",
            Message: "Your query has been submitted.",
          });
        } else {
          globalState.setNotificationObject({
            ShowPopup: true,
            Heading: "Alert",
            Message: response.data.Message,
          });
        }
        clearObject();
        SetShowContact(false);
        setLoadingState(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setLoadingState(false);
      });
  }

  function checkLoginValidation() {
    if (loginObject.username != "" && loginObject.password != "") {
      getUserLoggedIn();
    } else {
      globalState.setNotificationObject({
        ShowPopup: true,
        Heading: "Alert",
        Message: "Username and password required.",
      });
    }
  }

  function getUserLoggedIn() {
    setLoadingState(true);
    let object = {} as any;
    object.username = SanitizeHtml(loginObject.username);
    object.password = SanitizeHtml(loginObject.password);
    axios
      .post(
        AppContext.AppAuthBaseURL + "api/SiteUser/PFISSOLoginCred",
        object,
        { withCredentials: true }
      )
      .then((response) => {
        debugger;
        if (response.data.Status === 1) {
          let l_response = response.data.Data;
          if (l_response[0].RefKey == "tf") {
            setTwoFactorMessage(l_response[0].Token);
            setShowTwoFactorDiv(true);
          } else {
            window.location = AppContext.LinkMBT as any;
          }
        } else {
          globalState.setNotificationObject({
            ShowPopup: true,
            Heading: "Alert",
            Message: response.data.Message,
          });
        }
        setLoadingState(false);
      })
      .catch((error) => {
        console.error("There was an error!", error);
        setLoadingState(false);
      });
  }

  function verifyPassCode() {
    if (loginObject.otp && loginObject.otp != "") {
      setLoadingState(true);
      let object = {} as any;
      object.username = SanitizeHtml(loginObject.username);
      object.password = SanitizeHtml(loginObject.password);
      object.passcode = SanitizeHtml(loginObject.otp);
      axios
        .post(
          AppContext.AppAuthBaseURL +
            "api/SiteUser/PFISSOLoginCredTwofactorAuth",
          object,
          { withCredentials: true }
        )
        .then((response) => {
          debugger;
          if (response.data.Status === 1) {
            let l_response = response.data.Data;
            window.location = AppContext.LinkMBT as any;
          } else {
            if (response.data.Status === -999) {
              setTwoFactorMessage("");
              setShowTwoFactorDiv(false);
            }

            globalState.setNotificationObject({
              ShowPopup: true,
              Heading: "Alert",
              Message: response.data.Message,
            });
          }
          setLoadingState(false);
        })
        .catch((error) => {
          console.error("There was an error!", error);
          setLoadingState(false);
        });
    } else {
      globalState.setNotificationObject({
        ShowPopup: true,
        Heading: "Alert",
        Message: "Please Enter OTP",
      });
    }
  }

  return (
    <>
      {loadingState && <LoadingAnimation />}
      <div className="login-main">
        <div className="fixed-back"></div>
        {hideLoginBox == false && (
          <div className="login-box">
            <div className="logo-sm">
              <img src="images/logo-black.png" width="148px" height="45px" />
            </div>
            {/* <span className="demo-app-txt">Demo APP</span> */}
            {!showTwoFactorDiv && (
              <>
                <span className="login-title">LOG IN</span>
                <div className="login-input">
                  <input
                    type="text"
                    value={loginObject.username}
                    onChange={(e) =>
                      setLoginObject((prevState: any) => ({
                        ...prevState,
                        username: e.target.value,
                      }))
                    }
                    placeholder="Username"
                  />
                </div>
                <div className="login-input">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={loginObject.password}
                    onChange={(e) =>
                      setLoginObject((prevState: any) => ({
                        ...prevState,
                        password: e.target.value,
                      }))
                    }
                    placeholder="Password"
                  />

                  <a
                    onClick={() => setShowPassword(!showPassword)}
                    className="show-hide-pass"
                  >
                    {!showPassword && (
                      <img
                        src="/images/eye-b.svg"
                        width="20"
                        height="20"
                        alt="Eye"
                      />
                    )}
                    {showPassword && (
                      <img
                        src="/images/eyeslash-b.svg"
                        width="20"
                        height="20"
                        alt="Eye-Slash"
                      />
                    )}
                  </a>
                </div>
                <a className="login-btn" onClick={() => checkLoginValidation()}>
                  Login
                </a>
              </>
            )}

            {showTwoFactorDiv && (
              <>
                <span className="login-title pass-title">
                  {twoFactorMessage}
                </span>
                <div className="login-input">
                  <input
                    type="text"
                    value={loginObject.otp}
                    onChange={(e) =>
                      setLoginObject((prevState: any) => ({
                        ...prevState,
                        otp: e.target.value,
                      }))
                    }
                    placeholder="OTP"
                  />
                </div>

                <a className="login-btn" onClick={() => verifyPassCode()}>
                  Login
                </a>
              </>
            )}

            <div className="login-forgot">
              Trouble Logging in? Please{" "}
              <a
                className="text-u"
                onClick={() => {
                  ShowHideContact();
                }}
              >
                Click Here
              </a>
            </div>
            <div className="login-pfi">
              <img src="images/plusfourintl.png" width="13px" height="14px" />
              <span>Plus Four International</span>
            </div>
            <span className="copy-right-login">
              Copyright © {currentYearDisplay()} Plus Four International
              Limited.
            </span>
          </div>
        )}
      </div>

      {ShowContact && (
        <div className="popup-help">
          <div className="help-popup-display">
            <div className="help-inner">
              <div className="help-head">
                <h3>Contact Support</h3>
                <a className="close-help" onClick={ShowHideContact}>
                  <img
                    src="/images/close.svg"
                    width="15px"
                    height="15px"
                    alt="cross"
                  />
                </a>
              </div>
              <div className="help-row">
                <p>Name:</p>
                <input
                  value={contactObject.Name}
                  onChange={(e) =>
                    setcontactObject((prevState: any) => ({
                      ...prevState,
                      Name: e.target.value,
                    }))
                  }
                  placeholder="your name"
                  type="text"
                />
              </div>
              <div className="help-row">
                <p>Email:</p>
                <input
                  value={contactObject.Email}
                  onChange={(e) =>
                    setcontactObject((prevState: any) => ({
                      ...prevState,
                      Email: e.target.value,
                    }))
                  }
                  placeholder="your email address"
                  type="text"
                />
              </div>
              {/* <div className="help-row">
              <p>Subject:</p>
              <input
                value={contactObject.Subject}
                onChange={(e) =>
                  setcontactObject((prevState: any) => ({
                    ...prevState,
                    Subject: e.target.value,
                  }))
                }
                placeholder="Subject"
                type="text"
              />
            </div> */}
              <div className="help-row">
                <p>Type:</p>
                <select
                  className="input-field select-field"
                  defaultValue={contactObject.ContactReason}
                  onChange={(e) =>
                    setcontactObject((prevState: any) => ({
                      ...prevState,
                      ContactReason: e.target.value,
                    }))
                  }
                >
                  <option value="">Select</option>
                  {contactUsReason &&
                    contactUsReason.map((Item: any, index) => (
                      <option
                        value={Item.PTSupportTypeID}
                        key={Item.PTSupportTypeID}
                      >
                        {Item.Name}
                      </option>
                    ))}
                </select>
              </div>
              <div className="help-row help-area">
                <p>Message:</p>
                <textarea
                  value={contactObject.Message}
                  onChange={(e) =>
                    setcontactObject((prevState: any) => ({
                      ...prevState,
                      Message: e.target.value,
                    }))
                  }
                  placeholder="type your message..."
                ></textarea>
              </div>
              <div className="help-row help-area flex-start">
                <p>File/Image:</p>
                <div className="drad-drop">
                  <DragDrop
                    ParentFeatures={dragDropFeatures}
                    DragDropCallback={handleDragDropCallback}
                    TriggerChild={triggerChild}
                  />
                </div>
              </div>
              <div className="help-btns">
                {/* onClick={() => checkValidation(true)} */}
                <a>Submit</a>
                <a onClick={ShowHideContact}>Cancel</a>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default React.memo(PFIJLRLGN);
